module.exports = __webpack_public_path__ + "static/media/1014781.fc831822.jpg";